module.exports = __webpack_public_path__ + "img/writingbg.49a727c7.png";